/**
 * Created by razial on 30.01.2023
 */

cc.SpineAction = function (spine, animation, duration, callback) {
    const data = spine.getAnimationData(animation);
    if (!data) {
        cleverapps.throwAsync(`no animation '${animation}' for json '${spine.spine.jsonName}'`);
    }

    this._spine = spine;
    this._animation = animation;
    this._desiredDuration = duration;
    this._callback = callback;
    this._completed = false;

    cc.ActionInterval.prototype.constructor.call(this, duration || (data && data.duration) || 0);
};

cc.SpineAction.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.SpineAction,

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);

        const spine = this._spine;
        const desiredDuration = this._desiredDuration;

        spine.setAnimation(0, this._animation, false);

        this._savedTimeScale = undefined;

        if (desiredDuration && desiredDuration !== spine.getTimeLeft()) {
            this._savedTimeScale = spine.getTimeScale();
            spine.setTimeScale(spine.getTimeLeft() / desiredDuration);
        }

        spine.setCompleteListener(this._complete.bind(this));
    },

    _complete: function () {
        this._spine.setCompleteListener();

        if (this._savedTimeScale) {
            this._spine.setTimeScale(this._savedTimeScale);
        }

        if (this._callback) {
            this._callback();
        }

        this._completed = true;
    },

    isDone: function () {
        return this._completed;
    },

    update: function () {
    },

    _autoFinalize: function () {
        if (!this._completed) {
            this._complete();
        }
    }
});
